export const getAppVersion = () => `${__HYDRA__APP__VERSION__}+${__COMMIT_HASH__}`;

/** When this build was made, in milliseconds since the epoch. */
export const getBuildTimestamp = () => __BUILD_TIMESTAMP__;
